import React, { useEffect, Suspense } from "react";
import { connect } from "react-redux";
import userManager from "./auth/userManager";
import FullAppSpinner from "./components/UI/FullAppSpinner/FullAppSpinner";

import "./App.css";
import AccountVerification from "./pages/AccountVerification/AccountVerification";
import Layout from "./containers/Layout/Layout";
import Dashboard from "./containers/Dashboard/Dashboard";
import { useTranslation } from "react-i18next";
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

function App(props) {
  const {
    user,
    loadingUser,
    verificationStatusReady,
    hasSubscription,
    menuIsReady,
    dispatch
  } = props;

  useEffect(() => {
    if (!loadingUser) {
      if (!user || user.expired) {
        setTimeout(() => {
          userManager.signinRedirect();
        }, 1000);
      }
    }
  }, [loadingUser, user]);

  let elem = <FullAppSpinner />;

  if (!loadingUser && user && !user.expired && verificationStatusReady) {
    elem = (
      <>
        <Suspense fallback={<FullAppSpinner />}>
          {hasSubscription ? (
            menuIsReady ? (
              <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_RECAPTCHA_KEY}>
                <Dashboard />
              </GoogleReCaptchaProvider>
            ) : (
              <></>
            )
          ) : (
            <>
              <Layout>
                <AccountVerification />
              </Layout>
            </>
          )}
        </Suspense>
      </>
    );
  }

  return elem;
}

const mapStateToProps = state => {
  return {
    user: state.oidc.user,
    loadingUser: state.oidc.isLoadingUser,
    menuIsReady: state.navigation.isReady,
    verificationStatusReady: !state.accountVerification.verificationStatus
      .fetching,
    accountIsVerified:
      state.accountVerification.verificationStatus.completed,
    hasSubscription:
      state.accountVerification.verificationStatus.subscriptionStatus.Exists
  };
};

export default connect(mapStateToProps)(App);
